import React from "react";
import {
    Box,
    DialogTitle,
    DialogActions,
    Button,
    DialogContent,
    Dialog,
    InputLabel,
    OutlinedInput,
    FormHelperText,
    FormControl,
} from "@mui/material";
import Fetching from "../../../Common/Fetching";

function NoteFormDialog(props) {
    const { title, setTitle, content, setContent } = props;
    const { onUpload, isUploading } = props;
    const { onClose } = props;
    const { action = "Add", type, confirmButton } = props;

    return (
        <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="md">
            <DialogTitle>
                {action} {type}
            </DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                        required={true}
                        error={!title}
                    >
                        <InputLabel
                            id="label-title"
                            sx={{ backgroundColor: "#FFF", padding: "0 4px" }}
                        >
                            Title
                        </InputLabel>
                        <OutlinedInput
                            id="text-title"
                            placeholder="Title"
                            autoFocus={true}
                            value={title}
                            onChange={setTitle}
                        />
                        <FormHelperText>Up to 250 characters</FormHelperText>
                    </FormControl>

                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                        required={true}
                        error={!content}
                    >
                        <InputLabel
                            id="label-content"
                            sx={{ backgroundColor: "#FFF", padding: "0 4px" }}
                        >
                            Content
                        </InputLabel>
                        <OutlinedInput
                            id="text-content"
                            placeholder="Content"
                            multiline
                            rows={6}
                            value={content}
                            onChange={setContent}
                        />
                        <FormHelperText>Add text here</FormHelperText>
                    </FormControl>
                </Box>
                {isUploading && <Fetching />}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    disabled={isUploading || !title || !content}
                    onClick={onUpload}
                >
                    {confirmButton || action}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NoteFormDialog;
